import { render, staticRenderFns } from "./AdminSandpitVisibilitySelector.vue?vue&type=template&id=572a7cfa&scoped=true&"
import script from "./AdminSandpitVisibilitySelector.vue?vue&type=script&lang=ts&"
export * from "./AdminSandpitVisibilitySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a7cfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
